var _tspan, _tspan2, _tspan3, _tspan4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTenOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133,
    height: 55,
    viewBox: "0 0 133 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": 10,
    transform: "translate(0 26)",
    style: {
      fontFamily: "MyriadPro-Bold,Myriad Pro",
      fontWeight: 700,
      fontSize: 35,
      letterSpacing: "-.05em",
      fill: "#f37b89"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10"))), /*#__PURE__*/React.createElement("text", {
    "data-name": "%",
    transform: "translate(40 23)",
    style: {
      letterSpacing: "-.03em",
      fontSize: 31,
      fontFamily: "MyriadPro-Bold,Myriad Pro",
      fontWeight: 700,
      fill: "#f37b89"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "%"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(74 27)",
    style: {
      fontSize: 36,
      fontFamily: "MyriadPro-Semibold,Myriad Pro",
      fontWeight: 600,
      letterSpacing: "-.03em",
      fill: "#f37b89"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "off"))), /*#__PURE__*/React.createElement("text", {
    "data-name": "on Medicines",
    transform: "translate(3 52)",
    style: {
      fill: "#666",
      fontSize: 20,
      fontFamily: "Gotham-Book,Gotham"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "on Medicines")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenOff);
export default __webpack_public_path__ + "static/media/tenOff.2a1c9b5c2aa03cd07cb454826d1d5a18.svg";
export { ForwardRef as ReactComponent };